
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/c/[category]",
      function () {
        return require("private-next-pages/listing/c/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/c/[category]"])
      });
    }
  